import { userConstants } from "../constants";
import { IUserAction } from "../common";

export const user = (state = {}, action: IUserAction) => {
  switch (action.type) {
    case userConstants.GET_PROFILE_REQUEST:
      return {
        id: action.id,
        loading: true
      };
    case userConstants.GET_PROFILE_SUCCESS:
      return {
        profile: action.profile
      };
    case userConstants.GET_PROFILE_FAILURE:
      return {
        error: action.error
      };
    case userConstants.GET_USER_REQUEST:
      return {
        id: action.id,
        loading: true
      };
    case userConstants.GET_USER_SUCCESS:
      return {
        user: action.user
      };
    case userConstants.GET_USER_FAILURE:
      return {
        error: action.error
      };
    default:
      return state;
  }
}